import { render, staticRenderFns } from "./addressSelectDialog.vue?vue&type=template&id=210b3638&scoped=true&"
import script from "./addressSelectDialog.vue?vue&type=script&lang=js&"
export * from "./addressSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./addressSelectDialog.vue?vue&type=style&index=0&id=210b3638&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b3638",
  null
  
)

export default component.exports